import { Attribute, ChangeDetectionStrategy, Component, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';

@Component({
  selector: 'cs-table-row',
  templateUrl: 'cs-table-row.html',
  host: { 'class': 'table-row' },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsTableRow {
  @Input() selected = false;
  @Output() rowClick = new EventEmitter<PointerEvent>();

  constructor(
    @Attribute('clickable') public clickable?: string,
    @Attribute('header') public header?: string
  ) {}

  @HostBinding('class.clickable') get isClickable() {
    return this.clickable !== null;
  }

  @HostBinding('class.selected') get isSelected() {
    return this.selected;
  }

  @HostBinding('class.header') get isHeader() {
    return this.header !== null;
  }

  @HostListener('click', ['$event'])
  onClick(event: PointerEvent) {
    if (this.clickable !== null) {
      this.rowClick.emit(event);
    }
  }
}
